import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

const Spinner = ({ spinProps, ...props }) => (
  <Spin indicator={<LoadingOutlined {...props} spin />} {...spinProps} />
);

export default Spinner;
